import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
    gridDataInicio:{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: 20,
        paddingTop: 10,
      },
}))

export default useStyle